<telxl-shared-overlay-modal size="lg">
    <ng-template #modalHeader>
        <header
            class="d-flex justify-content-between align-items-center w-100"
            aria-label="Transfer Modal Header"
        >
            <h2 class="font-lg weight-medium px-2 pt-2 mb-0">Transfer</h2>

            <telxl-button
                colour="secondary"
                size="lg"
                (buttonClick)="close()"
                (keydown.enter)="close()"
            >
                <i class="fa-light fa-lg fa-xmark"></i>
            </telxl-button>
        </header>
    </ng-template>

    <ng-template #modalBody>
        <section
            class="d-flex justify-content-center flex-column w-100"
            aria-label="Transfer Options"
        >
            <nav class="card-title mx-2" aria-label="Transfer Tabs">
                <telxl-tab
                    [tabs]="tabs()"
                    alignment="left"
                    [selected]="selected()"
                    (selectedChange)="setSelected($event)"
                    containerClass="d-inline-block"
                    justifyContentClass="justify-content-end"
                />
            </nav>
        </section>
        <div class="d-flex w-100 h-100">
            @if (selected() === 'queues') {
                <telxl-shared-transfer-queue
                    class="w-100"
                    [conversationId]="conversationId()"
                    [queueId]="queueId()"
                    (transfer)="transferToQueue($event)"
                />
            } @else if (selected() === 'agents') {
                <telxl-shared-active-agent-directory-panel
                    class="w-100"
                    [businessUnitId]="businessUnitId()"
                    [agentId]="agentId()"
                    [showPresenceFilter]="true"
                    [customButtonTemplate]="TransferButtonTemplate"
                    [presences]="['Busy', 'Idle']"
                    (clicked)="transferToAgent($event)"
                />
            }
        </div>
    </ng-template>
</telxl-shared-overlay-modal>

<ng-template #TransferButtonTemplate let-select="select">
    <telxl-button class="w-100" colour="light" (buttonClick)="select()">
        Transfer
    </telxl-button>
</ng-template>
